// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__TDcp7","footer_list":"Footer_footer_list__5sap3"};